/**
 * Texte der Version 10, für HR-Teams und Recruiter:innen. Pro Station eine
 * Headline und ein kurzer Satz, mehr nicht. Die Geschichte erzählt das
 * Spielbrett.
 */

export const APPS = 312

export const STEPS = {
  intro: {
    title: 'Jeder Werdegang beginnt mit einer Lücke.',
    line: 'Das ist die Geschichte von Lena. Sie beginnt, bevor Lena überhaupt davon weiß.'
  },
  luecke: {
    title: 'Im Customer Success fehlt jemand.',
    line: 'Die Tickets stapeln sich. Tina aus der Teamleitung meldet den Bedarf an HR.'
  },
  hr: {
    title: 'Neue Stelle, kein leeres Blatt.',
    line: 'Mara aus dem HR startet mit einer Aivy-Vorlage oder holt das Team direkt dazu.'
  },
  analyse: {
    title: 'Was heißt hier eigentlich passend?',
    line: 'Das Team schätzt die Anforderungen selbst ein, jede Person für sich am Smartphone.'
  },
  profil: {
    title: 'Jetzt hat die Lücke eine Form.',
    line: 'Aivy macht daraus ein Anforderungsprofil mit Ideal- und Übergangsbereichen, nach den Best Practices der DIN 33430.'
  },
  link: {
    title: 'Ein Link für alle Kanäle.',
    line: 'Karriereseite, Social Media oder Messe. Mit Aivy® Attract sehen Talente sofort, welche Stelle zu ihnen passt.'
  },
  flut: {
    title: 'Und dann kommen die Bewerbungen.',
    line: `Über ${APPS}. Viele klingen gleich, manche hat eine KI geschrieben. Wer passt wirklich?`
  },
  games: {
    title: 'Kein Problem, das Profil steht ja schon.',
    line: 'Alle Talente spielen kurze Spiele am Smartphone. Gemessen wird Verhalten, keine Selbstbeschreibung.'
  },
  talente: {
    title: 'Alle gehen mit etwas nach Hause.',
    line: 'Jedes Talent bekommt sein persönliches Stärkenprofil, auch bei einer Absage.'
  },
  magic: {
    title: 'Aus Spielen wird Passung.',
    line: 'Das Spielverhalten ergibt validierte Dimensionen. Aivy gleicht sie mit eurem Profil ab.'
  },
  liste: {
    title: 'Mara startet mit einer sortierten Liste.',
    line: `Statt ${APPS} Lebensläufe einzeln zu lesen, sieht sie die Passung aller auf einen Blick.`
  },
  regeln: {
    title: 'Erklärbar, ohne Blackbox.',
    line: 'Jedes Ergebnis lässt sich bis zur einzelnen Dimension begründen, auch gegenüber dem Team.'
  },
  report: {
    title: 'Lena passt. Und Mara weiß, warum.',
    line: 'Das Passungsprofil zeigt Chancen, Risiken und Interviewfragen. Rückfragen beantwortet der Aivy Assistent.'
  },
  gespraech: {
    title: 'Ein Gespräch, das in die Tiefe geht.',
    line: 'Mara fragt gezielt dort nach, wo es sich lohnt, und spart sich die Standardfragen.'
  },
  team: {
    title: 'Lena ergänzt, was dem Team fehlt.',
    line: 'Die Teamanalyse zeigt die Stärken im Team. Mit Talent vergleichen siehst du, wer die Lücke füllt.'
  },
  kreuz: {
    title: 'Jonas passt auch, nur woanders.',
    line: 'Das Kreuzmatching prüft alle offenen Stellen, ohne neues Assessment. Der Vertrieb freut sich.'
  },
  absagen: {
    title: 'Absagen, die niemand bereut.',
    line: 'Alle anderen bekommen eine begründete Absage und ihr Stärkenprofil. Wer will, bleibt im Talentpool.'
  },
  ats: {
    title: 'Zusage raus, alles im ATS.',
    line: 'Mit dem Sidebar-Plugin hast du Auswertung und Assistent direkt in softgarden, Personio oder Workday.'
  },
  start: {
    title: 'Willkommen im Team, Lena.',
    line: 'Die Lücke ist zu und der Stapel wird kleiner. Genau so war das gedacht.'
  },
  wachsen: {
    title: 'Lena wächst. Die Rolle auch.',
    line: 'Ein Jahr später sieht die Stelle anders aus. Der Vergleich der Anforderungsprofile zeigt, wo eine Schulung hilft.'
  },
  pool: {
    title: 'Die nächste Lücke? Diesmal nicht bei null.',
    line: 'Das Team wächst weiter. Im Talentpool wartet Aylin, ihr Profil passt schon.'
  },
  support: {
    title: 'Und wenn mal eine Frage offen ist?',
    line: 'Unser Support hilft schnell und persönlich, per Mail an help@aivy.app oder im kurzen Call.'
  },
  finale: {
    title: 'Aus einer Lücke wurde ein Werdegang.',
    line: 'Welche Lücke hat euer Team gerade? Wir zeigen dir, wie Aivy sie füllt.'
  }
}
